"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldContext = void 0;
var react_1 = __importDefault(require("react"));
exports.FormFieldContext = react_1.default.createContext({
    labelFor: undefined,
    inputRef: undefined,
    setFormFieldContext: function () { },
});
exports.FormFieldContext.displayName = 'FormFieldContext';
//# sourceMappingURL=FormFieldContext.js.map